export default __webpack_public_path__ + "static/media/home-search-cars.553962ce.jpg";